// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[data-v-2d2aeae8]{-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:.375rem;border-width:1px;width:5rem}td[data-v-2d2aeae8]{padding:.25rem;text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
